import { RoomReserved } from 'api/planning';
import { Icon, Popup } from 'semantic-ui-react';
import { ExistingSessionsInfo } from './ExistingSessionsInfo';

type Props = {
  reservations: RoomReserved[];
};

export const RoomReservedInfo = ({ reservations }: Props) => {
  return (
    <Popup
      trigger={<Icon data-testid="clashed-room" name="exclamation triangle" color="orange" />}
      children={<ExistingSessionsInfo reservations={reservations} />}
      position="bottom left"
    />
  );
};
